export default {"src":"/_next/static/image/public/images/ic_camera.a9203050b1a443ec8bf2dc191fb1e3f4.svg","height":38,"width":38};